<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1498 3.16695C10.8301 2.76736 10.21 2.80907 9.94675 3.24787L7.68806 7.01236C7.27391 7.70262 6.52795 8.12497 5.72298 8.12497H3.54163V16.0416H13.727C14.1967 16.0416 14.6083 15.7272 14.7319 15.2741L16.3228 9.44072C16.5036 8.77807 16.0047 8.12497 15.3179 8.12497H11.5053C10.7517 8.12497 10.2112 7.39852 10.4278 6.6767L11.2798 3.83667C11.3491 3.60564 11.3005 3.3553 11.1498 3.16695ZM8.87489 2.60475C9.58634 1.419 11.2621 1.30628 12.1259 2.38608C12.5331 2.89506 12.6643 3.57154 12.477 4.19586L11.6733 6.87497H15.3179C16.8289 6.87497 17.9264 8.31179 17.5288 9.76961L15.9379 15.6029C15.666 16.6 14.7604 17.2916 13.727 17.2916H3.41663C2.79531 17.2916 2.29163 16.788 2.29163 16.1666V7.99997C2.29163 7.37865 2.79531 6.87497 3.41663 6.87497H5.72298C6.08887 6.87497 6.42794 6.68299 6.6162 6.36924L8.87489 2.60475Z"
      :fill="fill"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.83337 17.2917C5.4882 17.2917 5.20837 17.0119 5.20837 16.6667L5.20837 7.50002C5.20837 7.15484 5.4882 6.87502 5.83337 6.87502C6.17855 6.87502 6.45837 7.15484 6.45837 7.50002L6.45837 16.6667C6.45837 17.0119 6.17855 17.2917 5.83337 17.2917Z"
      :fill="fill"
    />
  </svg>
</template>
<script>
import {DEFAULT_BRAND_SECONDARY_COLOR} from '../constants';

export default {
  inject: ['getBrandSecondaryBackground'],
  computed: {
    fill() {
      const stroke = this.getBrandSecondaryBackground();
      console.log('brand primary background: ', stroke);
      return stroke || DEFAULT_BRAND_SECONDARY_COLOR;
    },
  },
};
</script>
